import { ServiceRequest } from "../../api/ServiceRequest";

export class PumpTransactionRequest extends ServiceRequest {
  startDate?: string; // LocalDateTime → ISO string
  endDate?: string;
  pump?: number;
  nozzle?: number;
  fuelId?: number;
  userId?: number;

  constructor(init?: Partial<PumpTransactionRequest>) {
    super(init);
    Object.assign(this, init);
  }

  // Getters & Setters
  getStartDate(): string | undefined {
    return this.startDate;
  }
  setStartDate(value: string | undefined): void {
    this.startDate = value;
  }

  getEndDate(): string | undefined {
    return this.endDate;
  }
  setEndDate(value: string | undefined): void {
    this.endDate = value;
  }

  getPump(): number | undefined {
    return this.pump;
  }
  setPump(value: number | undefined): void {
    this.pump = value;
  }

  getNozzle(): number | undefined {
    return this.nozzle;
  }
  setNozzle(value: number | undefined): void {
    this.nozzle = value;
  }

  getFuelId(): number | undefined {
    return this.fuelId;
  }
  setFuelId(value: number | undefined): void {
    this.fuelId = value;
  }

  getUserId(): number | undefined {
    return this.userId;
  }
  setUserId(value: number | undefined): void {
    this.userId = value;
  }
}
